import { useRef } from "react";

import styles from "./index.less";

import { VideoInfoMessage } from "@/services/chat";

export default function VideoMessage({ msg }: { msg: VideoInfoMessage }) {
  const ref = useRef<HTMLVideoElement>(null);

  // useEffect(() => {
  //   const cb = () => {
  //     ref.current?.pause();
  //   };
  //   eventBus.on(EVENT_NAME.StopVoice, cb);
  //   return () => {
  //     eventBus.remove(EVENT_NAME.StopVoice, cb);
  //   };
  // }, []);

  return <video src={msg.url} controls ref={ref} className={styles.video} />;
}
